import { render, staticRenderFns } from "./customsDeclarationType.vue?vue&type=template&id=045b25d7&"
import script from "./customsDeclarationType.vue?vue&type=script&lang=js&"
export * from "./customsDeclarationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045b25d7')) {
      api.createRecord('045b25d7', component.options)
    } else {
      api.reload('045b25d7', component.options)
    }
    module.hot.accept("./customsDeclarationType.vue?vue&type=template&id=045b25d7&", function () {
      api.rerender('045b25d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/customsDeclarationType.vue"
export default component.exports